<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<span epub:type="pagebreak" id="pg_xii" title="xii">
<p class="IMG"><img alt="" height="401" src="images/Bloom-MittwochFamily_fmt.jpg" width="750"/></p>
<p class="page">
<span epub:type="pagebreak" id="pg_xiii" title="xiii">
</span></p><p class="IMG"><img alt="" height="402" src="images/MarshallFamilyTree-R_fmt.jpg" width="750"/></p>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// trees.vue?3e47c4e0